import React from "react";
import {
    Card,
    Table,
} from "antd";
import {Link} from "react-router-dom";

import memory from "../../../../../utils/memory";
import LinkButton from "../../../../crm/components/link-button";
import {moaApi} from "../../../../../api";
import {
    AGENCYCHARGE
} from "../../../../../utils/constant";
import tools from "../../../../../utils/tools";

const {
    reqAgencyList,
} = moaApi;

export default class AwardsAgencyList extends React.Component {
    state = {
        data: [],
        pagination: {},
        loading: false,
    };
    columns = [
        {
            title: '名称',
            dataIndex: 'name',
            key: 'name'
        },
        {
            title: '官网',
            dataIndex: 'official_website',
            key: 'official_website'
        },
        {
            title: '收费级别',
            dataIndex: 'charge_level',
            key: 'charge_level'
        },
        {
            title: '联系人数量',
            dataIndex: 'linkman',
            key: 'linkman',
        },
        {
            title: '创建时间',
            dataIndex: 'create_time',
            key: 'create_time',
        },
        {
            title: '创建人',
            dataIndex: 'creator',
            key: 'creator',
        },
        {
            title: '操作',
            dataIndex: 'option',
            valueType: 'option',
            render: (_, record) => {
                return (
                    <Link to={`/moa/awards/agency/detail/${record.key}`}>详情</Link>
                );
            }
        },
    ];

    handleTableChange = (pagination, filters, sorter) => {
        const pager = {...this.state.pagination};
        pager.current = pagination.current;
        this.setState({
            pagination: pager
        });
        let tmpFilters = {...filters};
        for(let item in tmpFilters) {
            if(tmpFilters[item]) {
                if(typeof(tmpFilters[item]) !== 'string' && item !== 'tags') {
                    tmpFilters[item] = tmpFilters[item][0];
                }
            }
        }
        let params = {
            page: pagination.current,
            //...this.state.searchObj,
            ...tmpFilters,
            type: 2
        };
        this.getAgencyList(params);
    }

    getAgencyList = async (params = {}) => {
        this.setState({
            loading: true
        });
        const response = await reqAgencyList(params);
        const pagination = {...this.state.pagination};
        const data = response.data;
        pagination.total = data.page.total;
        pagination.pageSize = data.page.node;
        let newData = [];
        for(let i = 0; i < data.data.length; i++) {
            const item = data.data[i];
            const obj = {
                key: item._id,
                name: <Link to={`/moa/awards/agency/detail/${item._id}`}>{item.name}</Link>,
                official_website: item.official_website || '-',
                charge_level: item.charge_level ? AGENCYCHARGE[item.charge_level-1].text : '未分类',
                linkman: item.linkman || 0,
                create_time: tools.unixToTime((new Date(item.create_at)).getTime()/1000),
                creator: item.creator.name || '-'
            };
            newData.push(obj);
        }
        this.setState({
            loading: false,
            data: newData,
            pagination
        });
    };

    componentDidMount() {
        this.getAgencyList({
            page: 1,
            type: 2
        });
    }

    render() {
        return (
            <Card
                title="代理机构列表"
                bordered={false}
                extra={<LinkButton to="/moa/awards/agency/add" txt="添加代理机构" />}
            >
                <Table
                    columns={this.columns}
                    dataSource={this.state.data}
                    pagination={this.state.pagination}
                    loading={this.state.loading}
                    onChange={this.handleTableChange}
                    scroll={{ x: 'max-content' }} // 加上这条  横向滚动  支持此属性的浏览器内容就不会换行了
                    size={memory.is_mobile ? 'small' : 'middle'}
                />
            </Card>
        );
    }
}